export default __webpack_public_path__ + "static/media/Lip_12_F.63d3f041.svg";